export const DISPLAY_ALL_CLASSES = 'All Classes';
export const DISPLAY_NO_SELECTION = '';
export const DISPLAY_MULTIPLE_CLASSES = 'Multiple Classes';
